import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import cx from 'classnames';
import styles from './FormButtons.scss';

class FormButtons extends Component {
  static propTypes = {
    previousVisible: PropTypes.bool,
    draftVisible: PropTypes.bool,
    onPrevious: PropTypes.func,
    onNext: PropTypes.func.isRequired,
    onSaveDraft: PropTypes.func.isRequired,
    top: PropTypes.bool,
    nextBtnText: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    switchForm: PropTypes.func,
    quickFormActive: PropTypes.bool,
    quickEnabled: PropTypes.bool,
  };

  static defaultProps = {
    previousVisible: true,
    draftVisible: false,
    top: true,
    onPrevious: () => null,
    nextBtnText: 'Next Step',
  };

  state = {
    sticked: false,
    stickPoint: 0,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, false);
    this.setState(() => ({
      stickPoint: this.el.offsetTop
    }), this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false);
  }

  onScroll = () => {
    if(window.scrollY < this.state.stickPoint) {
      this.setState(() => ({
        sticked: false
      }));
    } else if (this.el.getBoundingClientRect().top <= 15) {
      this.setState(() => ({
        sticked: true
      }));
    }
  }

  // Workaround, we want to wait a few ms for the blur functions to run.
  submittingHandler = () => {
    setTimeout( () => {
      this.props.onNext();
    }, 250);
  };

  render() {
    const {
      previousVisible,
      onPrevious,
      onSaveDraft,
      top,
      draftVisible,
      nextBtnText,
      isLoading,
      switchForm,
      quickFormActive,
      quickEnabled,
    } = this.props;

    const className = cx(styles.formButtons, {
      'mb-2': top,
      'card-footer card-footer--with-action': !top,
      [styles.formButtonsSticked]: this.state.sticked,
    });

    const quickVisible = quickEnabled && window.location.hash.match(/#\/(basics|quick)/i);

    return (
      <div className={this.state.sticked ? styles.contentPadder : null}>
        <div ref={(ref) => this.el = ref} className={className}>
          <div className={this.state.sticked ? 'container' : null}>
            <div className="row justify-content-center">
              <div className="col-md-10 d-flex justify-content-between">
                <div className="text-left">
                  {quickVisible && <Button color="info" onClick={() => switchForm()}>
                    {quickFormActive ? 'Advanced' : 'Quick'} Form
                    <i className="fa fa-refresh ml-2" aria-hidden="true"></i>
                  </Button>}
                  {previousVisible ? <Button color="link" onClick={onPrevious}>
                    <i className="fa fa-chevron-left mr-1" aria-hidden="true"></i>
                    Previous Step
                  </Button> : <span/>}
                </div>
                <div className="text-right">
                  {draftVisible && <Button color="link" onClick={onSaveDraft} disabled={isLoading}>
                    <i className="fa fa-save"></i> Save Draft
                  </Button>}
                  <Button color="success" onMouseDown={this.submittingHandler} disabled={isLoading} >
                    {nextBtnText}
                    <i className="fa fa-chevron-right ml-1" aria-hidden="true"></i>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.submissionForm.get('isLoading', false),
  draftVisible: state.config.get('draft_available', false),
  quickEnabled: state.config.get('quick_form_enabled', false),
  quickFormActive: state.form.eventSubmission.values.quick_form,
  recurringEvent: state.config.get('recurring_event', false)
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormButtons);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/FormButtons.jsx